// Types
import { ToolName, ToolType, ToolTypeValue } from "app/store/pagesToolbar/pagesToolbar.types";
// Components
import ColumnSwitcher from "app/components/ColumnSwitcher";
// 
import * as Filters from '../Filters';

const useGetTools = (toolType: ToolTypeValue) => {
  const filesTools = {
    // ToDO: Deprecated. Will be removed in few releases
    bar: {
      [ToolName.GoToLastOpenedPage]: Filters.GoToLastOpenedPage,
      [ToolName.GoToPage]: Filters.GoToPage
    },
    additionalBar: {
      [ToolName.NumberOfColumns]: ColumnSwitcher,
      [ToolName.PagesInWorkspace]: Filters.PagesInWorkspaceSelect,
      [ToolName.Tags]: Filters.TagsPicker,
      [ToolName.Colors]: Filters.ColorsPicker,
      [ToolName.HaveDuplicateInWorkspace]: Filters.HaveDuplicateInWorkspace
    },
    // New design
    newDesignBar: {
      [ToolName.NumberOfColumns]: ColumnSwitcher,
      [ToolName.GoToPage]: Filters.GoToPage,
      [ToolName.GoToLastOpenedPage]: Filters.GoToLastOpenedPage
    },
    newDesignSidebar: {
      [ToolName.EpisodeTypes]: Filters.EpisodeTypesSelect,
      [ToolName.EpisodeLabels]: Filters.EpisodeLabelsSelect,
      [ToolName.EpisodeAuthors]: Filters.EpisodeAuthorsSelect,
      [ToolName.Tags]: Filters.TagsPicker,
      [ToolName.PagesInWorkspace]: Filters.PagesInWorkspaceSelect,
      [ToolName.Colors]: Filters.ColorsPicker,
      [ToolName.HaveDuplicateInWorkspace]: Filters.HaveDuplicateInWorkspace
    }
  };
  const workspaceTools = {
    // ToDO: Deprecated. Will be removed in few releases
    bar: {
      [ToolName.GoToPostEvent]: Filters.GoToPostEvent,
      [ToolName.GoToLastOpenedPage]: Filters.GoToLastOpenedPage,
      [ToolName.GoToPage]: Filters.GoToPage
    },
    additionalBar: {
      [ToolName.NumberOfColumns]: ColumnSwitcher,
      [ToolName.EpisodeTypes]: Filters.EpisodeTypesSelect,
      [ToolName.EpisodeLabels]: Filters.EpisodeLabelsSelect,
      [ToolName.EpisodeAuthors]: Filters.EpisodeAuthorsSelect,
      [ToolName.Tags]: Filters.TagsPicker,
      [ToolName.Colors]: Filters.ColorsPicker,
      [ToolName.AdditionalBatchesOnly]: Filters.AdditionalBatchesOnly,
      [ToolName.HaveDuplicateInWorkspace]: Filters.HaveDuplicateInWorkspace
    },
    settings: {
      [ToolName.ExportPagesToPDF]: Filters.ExportPagesToPDFButton,
      [ToolName.WorkspaceViewMode]: Filters.WorkspaceViewModeGroup,
      [ToolName.SendToAIChat]: Filters.SendToAIChatButton
    },
    // New design
    newDesignBar: {
      [ToolName.NumberOfColumns]: ColumnSwitcher,
      [ToolName.WorkspaceViewMode]: Filters.WorkspaceViewModeGroup,
      // [ToolName.ExportPagesToPDF]: Filters.ExportPagesToPDFButton,
      // [ToolName.SendToAIChat]: Filters.SendToAIChatButton,
      [ToolName.GoToPage]: Filters.GoToPage,
      [ToolName.GoToPostEvent]: Filters.GoToPostEvent,
      [ToolName.GoToLastOpenedPage]: Filters.GoToLastOpenedPage
    },
    newDesignSidebar: {
      [ToolName.EpisodeTypes]: Filters.EpisodeTypesSelect,
      [ToolName.EpisodeLabels]: Filters.EpisodeLabelsSelect,
      [ToolName.EpisodeAuthors]: Filters.EpisodeAuthorsSelect,
      [ToolName.Tags]: Filters.TagsPicker,
      [ToolName.Colors]: Filters.ColorsPicker,
      [ToolName.AdditionalBatchesOnly]: Filters.AdditionalBatchesOnly,
      [ToolName.HaveDuplicateInWorkspace]: Filters.HaveDuplicateInWorkspace
    }
  };
  return toolType === ToolType.Files ? filesTools : workspaceTools;
}

export default useGetTools;
